export default __webpack_public_path__ + "static/media/ISKO CLASS-2 EXAM PATTERN 2025.6daacfd0.pdf";